import { Typography } from "@mui/material";
import profileIcon from "assets/admin/profile.svg";
import { LazyLoadImage } from "react-lazy-load-image-component";
import classes from "./style.module.scss";

export const ChatItem = ({ item, onClick }) => {
  return (
    <div className={classes.chatProfileItem} onClick={onClick}>
      <LazyLoadImage src={profileIcon} className={classes.chatProfileImage} />
      <div className={classes.chatProfileInfo}>
        <Typography className={classes.chatProfileName}>{item.title}</Typography>
        <Typography className={classes.chatProfileLastMessage}>
          {item.latest_message.message}
        </Typography>
      </div>
    </div>
  );
};
